import { Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import Logotype from "./Logotype.vue";

export default Node.create({
  name: "logotype",

  draggable: false,

  addAttributes() {
    return {
      src: {
        default: null
      }
    };
  },

  addCommands() {
    return {
      setLogotype: () => ({ chain }) => {
        return chain()
          .setNode(this.name)
          .run();
      },

      toggleLogotype: () => ({ chain }) => {
        return chain()
          .toggleNode(this.name)
          .run();
      },

      unsetLogotype: () => ({ chain }) => {
        return chain()
          .deleteNode(this.name)
          .run();
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "logotype"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["logotype", HTMLAttributes];
  },

  addNodeView() {
    return VueNodeViewRenderer(Logotype);
  }
});
